<template>
  <div>
    <AboutUsNav></AboutUsNav>
    <div class="aaboutwe_container">
      <h3
        class="aabout-h3"
        id='a'
      >拍界简介</h3>

      <div class="ajj123">
        <p>拍界（www.paijie.com）是拍界（吉林省）拍卖有限公司旗下在线实时拍卖平台，总部位于吉林省长春市。拍界是利用互联网技术，将传统的拍卖方式与网络结合到一起，为用户提供稳定、便捷的网上竞拍系统，使传统拍卖不再受地域限制，提供废旧行业领域产品的在线送拍、在线竞拍、在线委托出价等现代化便捷的拍卖方式。</p>
         
        <p>拍界在拍卖服务方面有着丰富的专业知识和经验，并与全国上万家大集团企业建立了良好的合作关系，拥有精准的竞买群体，专业化拍卖团队，完备的线下服务体系，致力于为广大从事废旧物资从业者提供拍卖商机。通过对广大行业市场的拓展，拍界在拍卖行业取得了良好口碑，合作伙伴遍布全国各地。以“持续的创新，不断的超越，为用户创造价值，让员工实现梦想”为使命，拍界向着“国际一流拍卖企业”稳步前进。</p>
        <p>拍界拍卖有限公司按照“总体规划、分步实施”的经营策略，全国设立七个大区，积极投身国内的城市化和现代化进程，并有选择的逐步进入海外发达经济体，实现国内市场和国外市场均衡发展。</p>
         
        <p>回顾过去，铿锵有力，步履坚实。</p>
        <p>展望未来，脚踏实地，戮力前行。</p>
        <p>大道至简，实干为要。</p>
      </div>
      <div class="aHui"></div>
      <img
        src="@/assets/images/About_One.jpg"
        class="aabout-im1"
      >
    </div>

  </div>
</template>
<script>
import { formatDate } from '@/assets/js/date.js';
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      subjects: [],
      //分页器
      paginator: {
        first: null,
        before: null,
        previous: null,
        current: 1,
        last: null,
        next: null,
        total_pages: null,
        total_items: null,
        limit: 20,
      },
    }
  },

  created () {
    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)

    // 加载路由参数
    // this.getRouteQuery()
    // 请求列表数据
    // this.getSubjects()

    // 页面至顶部
    window.scrollTo(0, 0);
  },
  components: {
    AboutUsNav
  }

}
</script>